import {
    USER_INFO,
    TOKEN
} from "../action-types/auth";

  const initialState = {
    user_info: null,
    token: ''
  }

  const authReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case USER_INFO:
        return {
          ...state,
          user_info: JSON.stringify(payload)
        };
      case TOKEN:
        return {
          ...state,
          token: payload
        };
      default:
        return state;
    }
  };

  export default authReducer;
  